<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-num">DAY 1</h2>
<h2 class="chap-title">23 DECEMBER 1948</h2>
<p class="noindent">Brigade 1 Battalion 13 initiated HOREV ground action with an attack in direction of Hill 86 – roughly midway between Gaza and Rafah – aimed at cutting off Egyptian forces in the Gaza Strip as well as to create a diversion from HOREV’s main effort at Auja sector. ILAF was tasked to dispatch four bombing sorties from midnight to sunset of Day 1 but a few Day 0 bombing sorties were delayed and actually flown during Day 1.</p>
<h3 class="sec1">RAID EL ARISH RAFAH</h3>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p6-2.jpg"/></p>
</div>
<p class="indent">There were reports of very bad weather from Ramat David to Tel Aviv and good weather from Tel Aviv to El Arish, with very good visibility over the target. The actual target was El Arish air base but this was not pinpointed, so 1401 diverted to Rafah as an alternative target, was over target from 0126 until 0145, bombed from 10,000 feet and reported:</p>
<div class="block-quote">
<p class="noindent">Captain: original target was not identified; hastily bombed what was believed to be Rafah. Over El Arish an explosion was heard and an orange flame was seen below aircraft. Discovery of enemy fighter prevented us from making a more thorough search for target. Enemy aircraft sighted by two crew members. The aircraft was believed to be twin-engined. No flak or searchlight over what believed to be El Arish or Rafah. Searchlight playing on the water near Gaza; no ships sighted. Radio Operator: Saw an aircraft; informed the pilot. Joined by navigator and pointed the aircraft out to him. He confirmed. Took violent evasive action but the aircraft managed to tail us for quite a long distance. We lost sight of him outside Gaza when the pilot did a 360 [degrees] turn over the sea [at] (1,000 feet).</p>
<p class="noindent">Navigator: Identified the plane as twin-engined.</p>
<p class="noindent">Pilot: Confirms the above.</p>
</div>
<p class="indent">As a result of the search for El Arish and due to the reported encounter with enemy aircraft, the C-47 landed at Tel Nof at 0201, refueled and returned to Ramat David at 0412.</p>
<h3 class="sec1">RAID EL ARISH RAFAH</h3>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p6-3.jpg"/></p>
</div>
<p class="indent">Also tasked to raid El Arish, also unable to pinpoint target and also diverted to attack Rafah from 0153 until 0154; is it possible that 1405 was the enemy aircraft that 1401 reported? 1405 pilot reported:</p>
<div class="block-quote">
<p class="noindent">Arrived west of target. Could not locate target properly because of lack of petrol. No signs of activity at El Arish, no searchlights or AAA. Went to Rafah; to the south of Rafah there were eight searchlights; located some dim lights and bombed them. Proceeded to Tel Nof, landing with 40 gallons of petrol.</p>
</div>
<p class="indent">The C-47 landed at Tel Nof at 0224, refueled and proceed to Ramat David where it landed at 0434. Crew concluded debrief with four complaints:</p>
<div class="block-quote">
<p class="noindent">- Quantity of petrol about 400 gallons, which does not allow for a climb of 10,000 feet or any emergency.</p>
<p class="noindent">- Met briefing extremely inaccurate – cloud of 8,000 feet thickness, rain, hail and icing.</p>
<p class="noindent">- Hang up; one of the bombs did not drop despite double effort at jettisoning.</p>
<p class="noindent">- Nothing to marshal the aircraft at Ramat David in a blinding rain.</p>
</div>
<h3 class="sec1">RAID GAZA FALUJA</h3>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p6-4.jpg"/></p>
</div>
<p class="indent">EGAF apparently retaliated circa 0400 when Tel Nof was bombed; ILAF reported three bombs with no casualties or damage while Adam Shatkai, pilot of 1405, reported:</p>
<a id="page7">
<div class="block-quote">
<p class="noindent">Took off from Tel Nof and on take-off the field was raided. Numerous hits could be seen in the vicinity (seven hits observed for sure).</p>
<h3 class="sec1">VELVETTA SPITFIRES</h3>
</div>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p7-1.jpg"/></p>
</div>
<p class="indent">Squadron 101 initiated HOREV with only five S199s, four Spitfires and two P-51s. ILAF planned to reinforce Squadron 101, in time for HOREV, with 12 Spitfires that were to be flown to Israel from Czechoslovakia, via Yugoslavia. Operation VELVETTA 2 was planned to include two flights, from Czechoslovakia to Israel, of six Spitfires each, but these were delayed due to bad weather. Six Spitfires were at Niksic, Yugoslavia, by morning of 23 December 1948 but one was unserviceable, so McElroy boarded the C-46 lead ship. Five Spitfires departed Niksic but Ruch’s 2013 malfunctioned after some 30 minutes so he turned back and returned to Niksic. Four Spitfires arrived at Israel. Three landed, as planned, at Tel Nof for AMU acceptance inspection; the other landed, not as planned, at Hatzor.</p>
<h3 class="sec1">RAIN AND RETREAT</h3>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p7-2.jpg"/></p>
</div>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p7-3.jpg"/></p>
<p class="fcap">Two VELVETTA 2 Spitfires – believed to be 2009 and 2011 – flying from Yugoslavia to Israel on 23 December 1948.</p>
</div>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p7-4.jpg"/></p>
<p class="fcap">Squadron 106 C-46 pilot Ray Foster poses beside the VELVETTA 2 Spitfire 2011 prior to flight from Yugoslavia to Israel.</p>
</div>
<div class="img_container">
<p class="imag"><img alt="figure" src="images/p7-5.jpg"/></p>
<p class="fcap">Squadron 101 pilot Caesar Dangott on the VELVETTA 2 Spitfire – with two underwing fuel tanks and one belly tank – at Niksic, Yugoslavia, prior to flight to Israel.</p>
</div>
<p class="indent">Rain started over Tel Aviv during the night of 22 to 23 December 1948, and although it would only start raining in the south from the evening of 23 December, ILAF operations slowed down; the only ILAF Day 1 daylight offensive operation was Flight 35 attacking Faluja.</p>
<p class="indent">Front D reported retreat from Hill 86 at 1815; an Egyptian counterattack pushed back Battalion 13 and frustrated the ILDF plan to wedge a strip of land between Gaza and Rafah. The same Front D message also reported pouring rain at Beer Sheba.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Chapter_002.vue?ae0a3cea